export default __webpack_public_path__ + "static/media/15yearsExp.00d3d475.jpg";